// extracted by mini-css-extract-plugin
module.exports = {"borderless":"iframe_borderless__qoG3t","fullWidth":"iframe_fullWidth__n8QY8"};